import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // When this controller connects, find and close the modal
    this.closeContactModal();
  }

  closeContactModal() {
    const dialog = document.querySelector('[data-contact-modal-target="dialog"]');
    if (dialog) {
      dialog.close();

      // Also dispatch event to ensure modal controller knows it's closed
      const modalElement = document.querySelector('[data-controller*="contact-modal"]');
      if (modalElement) {
        const event = new CustomEvent('modal:close');
        modalElement.dispatchEvent(event);
      }
    }
  }
}
